import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { Form, Formik } from 'formik'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { TRANSILE_SCHEMA } from '../../operacionNuevoTransilo/components/constants'
import { SiloDestinoParaAnularTransileSelect } from '../SiloDestinoParaAnularTransileSelect/SiloDestinoParaTransileSelect'

export const OperacionEliminarTransileView = ({ siloOrigen, aceptar, cancelar }) => (
  <Formik initialValues={{ siloDestino: '' }} onSubmit={aceptar} validationSchema={TRANSILE_SCHEMA}>
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2} direction='column' justify='space-around'>
          <Grid item>
            <Typography variant='h6'>Cancelar el último transile desde {siloOrigen}</Typography>
          </Grid>
          <Grid container item justify='space-between'>
            <Grid item xs={12} sm={6}>
              <Typography variant='body1'>Seleccione el destino del transile que desea anular</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <SiloDestinoParaAnularTransileSelect siloOrigen={siloOrigen} />
            </Grid>
          </Grid>
          <Grid container item justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                onClick={cancelar}
                color='secondary'
                startIcon={<HighlightOffIcon />}
                disabled={isSubmitting}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
)
